@let isDarkMode = corporateDesignService.isDarkModeActive();
@let corporateDesign = corporateDesignService.corporateDesign();
@let canGoBack = canShiftBack();
@let canGoForward = canShiftForward();

<button
  [type]="'button'"
  [id]="id() | appendTestId: 'year-picker'"
  [attr.data-testid]="id() | appendTestId: 'year-picker'"
  tabIndex="0"
  [ngStyle]="{
    color: textColor(),
    background: 'inherit',
  }"
  class="flex cursor-pointer flex-row"
  (keydown.space)="showYearPicker.set(!showYearPicker())"
  (click)="showYearPicker.set(!showYearPicker())">
  <div class="pointer-events-none">{{ shownYear() }}</div>
  <span class="material-symbols-rounded pointer-events-none"
    >arrow_drop_down</span
  >
</button>
@if (showYearPicker()) {
  <div
    [id]="id() | appendTestId: 'year-picker-popup'"
    [attr.data-testid]="id() | appendTestId: 'year-picker-popup'"
    class="border-input-ring absolute top-0 bottom-0 left-0 z-10 box-border w-full rounded-lg border-1 bg-inherit py-5"
    [ngClass]="{
      'bg-primary-on': !corporateDesignService.isDarkModeActive(),
    }"
    [ngStyle]="{
      borderRadius: borderRounding(),
      background: isDarkMode
        ? corporateDesign.colorAdmixtures.dark_surface_01
        : '',
    }">
    <div
      [id]="id() | appendTestId: 'year-select'"
      class="relative flex h-full w-full flex-row items-center justify-center">
      <div
        class="absolute left-0 flex h-full items-center"
        [id]="id() | appendTestId: 'to-earlier-years'">
        <span
          [id]="id() | appendTestId: 'to-earlier-years-icon'"
          [attr.data-testid]="id() | appendTestId: 'to-earlier-years'"
          tabIndex="0"
          class="material-symbols-rounded !text-6xl"
          [ngClass]="{
            'cursor-pointer': canGoBack,
            'pointer-events-none cursor-not-allowed opacity-20': !canGoBack,
          }"
          (keydown.enter)="shiftYearsBack()"
          (click)="shiftYearsBack()"
          >chevron_left</span
        >
      </div>
      <div
        class="absolute right-0 flex h-full items-center"
        [id]="id() | appendTestId: 'to-future-years'">
        <span
          tabIndex="0"
          [id]="id() | appendTestId: 'to-future-years-icon'"
          [attr.data-testid]="id() | appendTestId: 'to-future-years'"
          class="material-symbols-rounded !text-6xl"
          [ngClass]="{
            'cursor-pointer': canGoForward,
            'pointer-events-none cursor-not-allowed opacity-20': !canGoForward,
          }"
          (keydown.enter)="shiftYearsForward()"
          (click)="shiftYearsForward()"
          >chevron_right</span
        >
      </div>
      <ul
        class="grid w-full grid-cols-3 gap-3 px-16"
        [id]="id() | appendTestId: 'years'"
        [attr.data-testid]="id() | appendTestId: 'years'">
        @for (year of years(); track year) {
          @let isYearBeforeMin = year | IsYearBeforeMin: min();
          @let isYearAfterMax = year | IsYearAfterMax: max();
          @let isNotInListDates =
            year | IsYearNotInDateList: restrictedDateList();
          <li
            tabindex="0"
            class="hover:bg-input-focus/20 cursor-pointer rounded-3xl px-2 py-1 text-center"
            [id]="id() | appendTestId: 'year-label-' + $index"
            [attr.data-testid]="id() | appendTestId: 'year-' + $index"
            [ngClass]="{
              'border-input-focus bg-input-focus font-semibold text-white':
                year === currentYear(),
              'pointer-events-none cursor-not-allowed opacity-20':
                isYearBeforeMin || isYearAfterMax || isNotInListDates,
            }"
            [ngStyle]="{
              background:
                year === currentYear()
                  ? focusColor()
                  : highlightedYears.includes(year)
                    ? focusColor() + '33'
                    : '',
            }"
            (mouseenter)="highlightedYears.push(year)"
            (mouseleave)="removeFromHighlightedYears(year)"
            (keydown.enter)="selectYear(year)"
            (click)="onYearChange.emit(year); showYearPicker.set(false)">
            {{ year }}
          </li>
        }
      </ul>
    </div>
  </div>
}
